import { CommunicationTemplateType } from "@bbj-types/communication/enum";
import { Switch } from "@mui/material";
import { Typography } from "@mui/material";
import { FormControlLabel, Stack } from "@mui/material";
import { CreateAction } from "@root/utils/enums/communication";
import { type Control, Controller } from "react-hook-form";

const setSwithLabel = {
  [CommunicationTemplateType.EMAIL]: "Copier le contenu de l'email dans cette action",
  [CommunicationTemplateType.SMS]: "Copier le contenu du SMS dans cette action",
};

export interface ICreateActionsProps {
  control: Control<{ createAction: CreateAction }, void>;
  type: CommunicationTemplateType;
}

export const CreateActions = ({ control, type }: ICreateActionsProps) => {
  return (
    <Stack
      sx={{
        gap: 0,
      }}
    >
      <Controller
        name="createAction"
        control={control}
        defaultValue={CreateAction.NONE}
        render={({ field }) => (
          <FormControlLabel
            control={
              <Switch
                {...field}
                sx={{ marginRight: 1, marginLeft: 1 }}
                checked={field.value > CreateAction.NONE}
                onChange={(_, checked) => field.onChange(checked ? CreateAction.CREATE : CreateAction.NONE)}
              />
            }
            label={<Typography variant="body1">Créer une action automatique</Typography>}
          />
        )}
      />
      <Controller
        name="createAction"
        control={control}
        render={({ field }) => (
          <FormControlLabel
            disabled={field.value === CreateAction.NONE}
            control={
              <Switch
                {...field}
                sx={{ marginRight: 1, marginLeft: 1 }}
                checked={field.value > CreateAction.CREATE}
                onChange={(_, checked) =>
                  field.onChange(checked ? CreateAction.CREATE_AND_LINK_EMAIL : CreateAction.CREATE)
                }
              />
            }
            label={<Typography variant="body1">{setSwithLabel[type]}</Typography>}
          />
        )}
      />
    </Stack>
  );
};
